<template>
  <component
    v-bind:is="
      'c' +
      (campo.cmp_tipo == 'componente' ||
      (campo.cmp_tipo == 'join' && campo.componente) ||
      (campo.cmp_tipo == 'manual' && campo.componente)
        ? 'c-' + campo.componente
        : campo.cmp_tipo)
    "
    v-bind:value="value"
    v-on:input="(event) => $emit('input', event)"
    :campo="campo"
    :crud="crud"
    :row="row"
    :modo="modo || tiposhow"
    solo
  ></component>
</template>

<script>
const components = {};
for (let cnome of global.reqClass.componentes_client) {
  components["c" + cnome] = global.reqClass.requirecmpmix(
    "@/lib/componente/" + cnome
  );
}

for (let cnome of global.reqClass.filtro_client) {
  components["cfiltro" + cnome] = global.reqClass.requirecmpmix(
    "@/lib/filtro/" + cnome + ".vue"
  );
}

export default {
  props: ["value", "campo", "crud", "row", "modo"],
  data() {
    return {
      tiposhow: this.modo
        ? this.modo
        : this.crud.action == "edit" && this.campo.cmp_viewmode == true
        ? "viewmode"
        : this.crud.action,
    };
  },
  methods: {},

  components,
};
</script>

<style scoped></style>
